module.exports = __webpack_public_path__ + "static/media/expenses.db2e0018.png";